import { render, staticRenderFns } from "./LoaneoLogo.vue?vue&type=template&id=6a8b78bf&scoped=true"
import script from "./LoaneoLogo.vue?vue&type=script&lang=js"
export * from "./LoaneoLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b78bf",
  null
  
)

export default component.exports